import { ModulePrefixes } from "enums";
import { useSearch } from "helpers";
import { useUserPermissions } from "hooks/user";
import { t } from "i18next";
import LeftMenuCard from "leftMenu/LeftMenuCard";
import { useLocation } from "react-router-dom";
import { getGeneralMenu } from "staticData";

export default function GeneralMenu() {
  const { search } = useLocation();
  const { web = null } = useSearch();
  const { delete_site } = useUserPermissions();

  return (
    <>
      <div className="card-div">
        {getGeneralMenu({ delete_site })
          .filter((item) => item)
          .map((item, index) => (
            <LeftMenuCard
              key={`${index}-${item.module}`}
              {...item}
              title={t(item.title)}
              prefix={web ? ModulePrefixes.SITE_SETTINGS: ModulePrefixes.SITE_TEMPLATE}
              link={`${web ? ModulePrefixes.SITE_SETTINGS: ModulePrefixes.SITE_TEMPLATE}/${item.module}${
                search ?? ""
              }`}
            />
          ))}
      </div>
    </>
  );
}
